import { LocalShipping, Warehouse } from "@mui/icons-material";
import { Card, CardContent, Chip, Grid, LinearProgress, Link, Tooltip } from "@mui/material/";
import { cloneDeep } from "lodash";
import { memo, useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Api from "../../Api";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IDispatchRequest } from "../../interfaces";
import { EmptyContent } from "./EmptyContent";
import './index.scss';
import { WidgetHeader } from "./WidgetHeader";

export const DispatchRequestWidget = memo(() => {
    const permissionContext = useContext(PermissionContext);
    const permitted = () => {
        return permissionContext.isPermitted(Feature.DispatchRequest);
    }

    const hasRequests = () => {

        if (!permitted()) return false;

        if (dispatchRequests)
            return dispatchRequests.length > 0
        return false;
    }

    const [dispatchRequests, setDispatchRequests] = useState<IDispatchRequest[] | null>(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [pending, setPending] = useState(false);

    useEffect(() => {
        if (dataLoading && !pending) {
            setPending(true);

            Api.Dispatches.getByStatus("open").then(x => {

                let list = cloneDeep(x as IDispatchRequest[]).reverse();

                setDispatchRequests(list);
                setDataLoading(false);
            });
        }
    })



    return (
        <Card elevation={3} className="dashboard-widget dashboard-widget-box">
            <WidgetHeader><LocalShipping sx={{ mr: 1 }} /> Dispatch Requests</WidgetHeader>
            <CardContent sx={{ height: "80%", overflowY: "auto", scrollbarWidth: "thin" }}>

                {dataLoading ? <LinearProgress /> :

                    hasRequests() ?
                        <ul className="widget-list">
                            {dispatchRequests && dispatchRequests.map((s, i) => {



                                return <li key={i}>
                                    <Tooltip title={`${s.reference ?? "No Reference"} (${s.dateCreated && new Date(s.dateCreated).toLocaleDateString("en-GB")})`}>
                                        <Link
                                            component={RouterLink}
                                            to={"/dispatchrequest/update/" + s.dispatchRequestId}>
                                            <Grid container justifyContent="space-between">
                                                <span>{s.reference ?? "No Reference"}</span>
                                                <Chip
                                                    label={s.statusName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>

                                        </Link>
                                    </Tooltip>
                                </li>
                            })



                            }
                        </ul>
                        :

                        <EmptyContent
                            contentType={"dispatch requests" + (permitted() ? "" : " (You do not have permission to view dispatch requests)")}
                            icon={<LocalShipping fontSize="inherit" />}
                        />
                }

            </CardContent>
        </Card >
    );

});
